
import { ref, watch, watchEffect } from "vue";
import { defineComponent } from "vue";
import Calendar from "primevue/calendar";
import Ripple from "primevue/ripple";
import Dropdown from "primevue/dropdown";
import InputText from "primevue/inputtext";
import OrderCard from "../components/OrderCard.vue";
import axios from "axios";
import Skeleton from "primevue/skeleton";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { useRouter, useRoute } from "vue-router";
import store from "../store";

const axioCred = axios.create({
  withCredentials: true,
});

export default defineComponent({
  name: "Orders",
  components: {
    OrderCard,
    Calendar,
    Dropdown,
    InputText,
    Skeleton,
  },
  setup() {
    function getInputFilter() {
      const searchFilter = sessionStorage.getItem("search");
      if (searchFilter) {
        return JSON.parse(searchFilter);
      } else {
        return "";
      }
    }
    function getDateFilter() {
      const dateFilter = sessionStorage.getItem("dates");

      if (dateFilter) {
        const parseDates = JSON.parse(dateFilter);
        return [new Date(parseDates[0]), new Date(parseDates[1])];
      } else {
        return null;
      }
    }
    function getStateNameFilter() {
      const stateNameFilter = sessionStorage.getItem("stateName");
      if (stateNameFilter) {
        return JSON.parse(stateNameFilter);
      } else {
        return "Без фильтрации";
      }
    }
    function getStateCodeFilter() {
      const stateCodeFilter = sessionStorage.getItem("stateCode");
      if (stateCodeFilter) {
        return JSON.parse(stateCodeFilter);
      } else {
        return "99";
      }
    }
    // data for calendar
    const placeholder = "Выберите период";
    let today = new Date();
    let month = today.getMonth();
    let year = today.getFullYear();
    let prevMonth = month === 0 ? 11 : month - 1;
    let prevYear = prevMonth === 11 ? year - 1 : year;
    let nextMonth = month === 11 ? 0 : month + 1;
    let nextYear = nextMonth === 0 ? year + 1 : year;

    const minDate = ref(new Date());
    const maxDate = ref(new Date());
    const invalidDates = ref();
    const dates1 = ref();
    const dates2 = ref(getDateFilter());

    minDate.value.setMonth(prevMonth);
    minDate.value.setFullYear(prevYear);
    maxDate.value.setMonth(nextMonth);
    maxDate.value.setFullYear(nextYear);

    let invalidDate = new Date();
    invalidDate.setDate(today.getDate() - 1);
    invalidDates.value = [today, invalidDate];

    //Data for dropdown select
    let selectedState = ref({
      name: getStateNameFilter(),
      code: getStateCodeFilter(),
    });
    const states = ref([
      { name: "Все заказы", code: "0" },
      { name: "Забронирован", code: "40" },
      { name: "Обрабатывается", code: "55" },
      { name: "Оформлен", code: "60" },
      { name: "Отменён", code: "70" },
    ]);
    const router = useRouter();
    const route = useRoute();
    let inputValue = ref(getInputFilter());
    const isLoading = ref(true);
    const error = ref(null);
    let activeOrders = ref(store.state.orders);
    let userOrders = ref(store.state.orders);
    //Function for filtering only active orders
    const activeUserOrders = (userOrders: any) => {
      let todayDate = new Date();
      let activeOrder = userOrders.filter(function (order: any) {
        return (
          todayDate <= new Date(order.DepInfo.depDate) ||
          todayDate <= new Date(order.DepInfo.backDate)
        );
      });
      activeOrder = activeOrder.sort((a: any, b: any) => {
        let sortDateA = new Date(a.DepInfo.depDate);
        let sortDateB = new Date(b.DepInfo.depDate);
        return +sortDateB - +sortDateA;
      });
      return (activeOrders.value = activeOrder);
    };
    // watch (inputValue, (newValue: any, oldValue: any) => {
    //   console.log(inputValue);
    //   console.log(newValue);
    //   console.log(oldValue);
    // });

    //Fetch GetUserOrders value, sorting it on date, then dispatching store action, then call function
    //for filtering only active orders
    const getOrders = async () => {
      isLoading.value = true;
      try {
        const json = await axioCred.get(
          "https://www.biletdv.ru/customer/IBEServices/GetUserOrders"
        );
        let fetchedOrders = await json.data.orders;
        userOrders.value = fetchedOrders.sort((a: any, b: any) => {
          let sortDateA = new Date(a.DepInfo.depDate);
          let sortDateB = new Date(b.DepInfo.depDate);
          return +sortDateB - +sortDateA;
        });
        store.dispatch("fetchOrders");
        isLoading.value = false;
        activeUserOrders(userOrders.value);
      } catch (err) {
        if (err.response.status == 401) {
          store.dispatch("auth/logout");
          router.push("/login");
        }
      }
    };
    watch(
      [inputValue, selectedState, dates2, userOrders],
      (newValue: any, oldValue: any) => {
        let choosenFilters = {
          dates: dates2.value,
          searchInput: inputValue.value,
          choosenState: selectedState.value,
        };
        if (
          choosenFilters.dates == null &&
          (choosenFilters.choosenState.name == "Все заказы" ||
            choosenFilters.choosenState.name == "Без фильтрации") &&
          choosenFilters.searchInput !== ""
        ) {
          let value: string = choosenFilters.searchInput;
          if (value) {
            activeOrders.value = userOrders.value.filter(function (order: any) {
              return (
                value
                  .toLowerCase()
                  .split(" ")
                  .every((v: any) =>
                    order.DepInfo.depCity.toLowerCase().includes(v)
                  ) ||
                value
                  .toLowerCase()
                  .split(" ")
                  .every((v: any) =>
                    order.DepInfo.destCity.toLowerCase().includes(v)
                  ) ||
                value
                  .toLowerCase()
                  .split(" ")
                  .every((v: any) =>
                    order.DepInfo.airlines.toLowerCase().includes(v)
                  ) ||
                value
                  .toLowerCase()
                  .split(" ")
                  .every((v: any) => order.Id.toString().includes(v))
              );
            });
          }
        } else if (
          choosenFilters.dates == null &&
          choosenFilters.choosenState.code == "0" &&
          choosenFilters.searchInput == ""
        ) {
          if (selectedState.value.name == "Все заказы") {
            activeOrders.value = userOrders.value.filter(function (order: any) {
              return (
                order.State == 40 ||
                order.State == 55 ||
                order.State == 65 ||
                order.State == 60 ||
                order.State == 70 ||
                order.State == 71 ||
                order.State == 72 ||
                order.State == 73 ||
                order.State == 74
              );
            });
          }
        } else if (
          choosenFilters.dates == null &&
          choosenFilters.choosenState.name !== "Все заказы" &&
          choosenFilters.searchInput == ""
        ) {
          if (selectedState.value.name! == "Забронирован") {
            activeOrders.value = userOrders.value.filter(function (order: any) {
              return order.State == 40;
            });
          } else if (selectedState.value.name == "Обрабатывается") {
            activeOrders.value = userOrders.value.filter(function (order: any) {
              return order.State == 55 || order.State == 65;
            });
          } else if (selectedState.value.name == "Оформлен") {
            activeOrders.value = userOrders.value.filter(function (order: any) {
              return order.State == 60;
            });
          } else if (selectedState.value.name == "Отменён") {
            activeOrders.value = userOrders.value.filter(function (order: any) {
              return (
                order.State == 70 ||
                order.State == 71 ||
                order.State == 72 ||
                order.State == 73 ||
                order.State == 74
              );
            });
          }
        } else if (
          choosenFilters.dates !== null &&
          (choosenFilters.choosenState.name == "Все заказы" ||
            choosenFilters.choosenState.name == "Без фильтрации") &&
          choosenFilters.searchInput == ""
        ) {
          if (choosenFilters.dates !== null) {
            let choosedDate = choosenFilters.dates!;

            if (
              choosedDate !== null &&
              choosedDate[0] !== null &&
              choosedDate[1] !== null
            ) {
              activeOrders.value = userOrders.value.filter(function (
                order: any
              ) {
                return (
                  new Date(order.DepInfo.depDate) >= new Date(choosedDate[0]) &&
                  new Date(order.DepInfo.depDate) <= new Date(choosedDate[1])
                );
              });
            }
          }
        } else if (
          choosenFilters.dates == null &&
          choosenFilters.choosenState.name !== "Все заказы" &&
          choosenFilters.searchInput !== ""
        ) {
          let value: string = choosenFilters.searchInput;
          if (selectedState.value.name! == "Забронирован") {
            activeOrders.value = userOrders.value.filter(function (order: any) {
              return (
                order.State == 40 &&
                (value
                  .toLowerCase()
                  .split(" ")
                  .every((v: any) =>
                    order.DepInfo.depCity.toLowerCase().includes(v)
                  ) ||
                  value
                    .toLowerCase()
                    .split(" ")
                    .every((v: any) =>
                      order.DepInfo.destCity.toLowerCase().includes(v)
                    ) ||
                  value
                    .toLowerCase()
                    .split(" ")
                    .every((v: any) =>
                      order.DepInfo.airlines.toLowerCase().includes(v)
                    ) ||
                  value
                    .toLowerCase()
                    .split(" ")
                    .every((v: any) => order.Id.toString().includes(v)))
              );
            });
          } else if (selectedState.value.name == "Обрабатывается") {
            activeOrders.value = userOrders.value.filter(function (order: any) {
              return (
                (order.State == 55 || order.State == 65) &&
                (value
                  .toLowerCase()
                  .split(" ")
                  .every((v: any) =>
                    order.DepInfo.depCity.toLowerCase().includes(v)
                  ) ||
                  value
                    .toLowerCase()
                    .split(" ")
                    .every((v: any) =>
                      order.DepInfo.destCity.toLowerCase().includes(v)
                    ) ||
                  value
                    .toLowerCase()
                    .split(" ")
                    .every((v: any) =>
                      order.DepInfo.airlines.toLowerCase().includes(v)
                    ) ||
                  value
                    .toLowerCase()
                    .split(" ")
                    .every((v: any) => order.Id.toString().includes(v)))
              );
            });
          } else if (selectedState.value.name == "Оформлен") {
            activeOrders.value = userOrders.value.filter(function (order: any) {
              return (
                order.State == 60 &&
                (value
                  .toLowerCase()
                  .split(" ")
                  .every((v: any) =>
                    order.DepInfo.depCity.toLowerCase().includes(v)
                  ) ||
                  value
                    .toLowerCase()
                    .split(" ")
                    .every((v: any) =>
                      order.DepInfo.destCity.toLowerCase().includes(v)
                    ) ||
                  value
                    .toLowerCase()
                    .split(" ")
                    .every((v: any) =>
                      order.DepInfo.airlines.toLowerCase().includes(v)
                    ) ||
                  value
                    .toLowerCase()
                    .split(" ")
                    .every((v: any) => order.Id.toString().includes(v)))
              );
            });
          } else if (selectedState.value.name == "Отменён") {
            activeOrders.value = userOrders.value.filter(function (order: any) {
              return (
                (order.State == 70 ||
                  order.State == 71 ||
                  order.State == 72 ||
                  order.State == 73 ||
                  order.State == 74) &&
                (value
                  .toLowerCase()
                  .split(" ")
                  .every((v: any) =>
                    order.DepInfo.depCity.toLowerCase().includes(v)
                  ) ||
                  value
                    .toLowerCase()
                    .split(" ")
                    .every((v: any) =>
                      order.DepInfo.destCity.toLowerCase().includes(v)
                    ) ||
                  value
                    .toLowerCase()
                    .split(" ")
                    .every((v: any) =>
                      order.DepInfo.airlines.toLowerCase().includes(v)
                    ) ||
                  value
                    .toLowerCase()
                    .split(" ")
                    .every((v: any) => order.Id.toString().includes(v)))
              );
            });
          }
        } else if (
          choosenFilters.dates !== null &&
          (choosenFilters.choosenState.name == "Все заказы" ||
            choosenFilters.choosenState.name == "Без фильтрации") &&
          choosenFilters.searchInput !== ""
        ) {
          if (choosenFilters.dates !== null) {
            let value: string = choosenFilters.searchInput;
            let choosedDate = choosenFilters.dates!;

            if (
              choosedDate !== null &&
              choosedDate[0] !== null &&
              choosedDate[1] !== null
            ) {
              activeOrders.value = userOrders.value.filter(function (
                order: any
              ) {
                return (
                  new Date(order.DepInfo.depDate) >= new Date(choosedDate[0]) &&
                  new Date(order.DepInfo.depDate) <= new Date(choosedDate[1]) &&
                  (value
                    .toLowerCase()
                    .split(" ")
                    .every((v: any) =>
                      order.DepInfo.depCity.toLowerCase().includes(v)
                    ) ||
                    value
                      .toLowerCase()
                      .split(" ")
                      .every((v: any) =>
                        order.DepInfo.destCity.toLowerCase().includes(v)
                      ) ||
                    value
                      .toLowerCase()
                      .split(" ")
                      .every((v: any) =>
                        order.DepInfo.airlines.toLowerCase().includes(v)
                      ) ||
                    value
                      .toLowerCase()
                      .split(" ")
                      .every((v: any) => order.Id.toString().includes(v)))
                );
              });
            }
          }
        } else if (
          choosenFilters.dates !== null &&
          choosenFilters.choosenState.name !== "Все заказы" &&
          choosenFilters.searchInput == ""
        ) {
          let choosedDate = choosenFilters.dates!;

          if (selectedState.value.name! == "Забронирован") {
            activeOrders.value = userOrders.value.filter(function (order: any) {
              return (
                order.State == 40 &&
                new Date(order.DepInfo.depDate) >= new Date(choosedDate[0]) &&
                new Date(order.DepInfo.depDate) <= new Date(choosedDate[1])
              );
            });
          } else if (selectedState.value.name == "Обрабатывается") {
            activeOrders.value = userOrders.value.filter(function (order: any) {
              return (
                order.State == 55 ||
                (order.State == 65 &&
                  new Date(order.DepInfo.depDate) >= new Date(choosedDate[0]) &&
                  new Date(order.DepInfo.depDate) <= new Date(choosedDate[1]))
              );
            });
          } else if (selectedState.value.name == "Оформлен") {
            activeOrders.value = userOrders.value.filter(function (order: any) {
              return (
                order.State == 60 &&
                new Date(order.DepInfo.depDate) >= new Date(choosedDate[0]) &&
                new Date(order.DepInfo.depDate) <= new Date(choosedDate[1])
              );
            });
          } else if (selectedState.value.name == "Отменён") {
            activeOrders.value = userOrders.value.filter(function (order: any) {
              return (
                (order.State == 70 ||
                  order.State == 71 ||
                  order.State == 72 ||
                  order.State == 73 ||
                  order.State == 74) &&
                new Date(order.DepInfo.depDate) >= new Date(choosedDate[0]) &&
                new Date(order.DepInfo.depDate) <= new Date(choosedDate[1])
              );
            });
          }
        } else if (
          choosenFilters.dates !== null &&
          choosenFilters.choosenState.name !== "Все заказы" &&
          choosenFilters.searchInput !== ""
        ) {
          let choosedDate = choosenFilters.dates!;
          let value: string = choosenFilters.searchInput;
          if (selectedState.value.name! == "Забронирован") {
            activeOrders.value = userOrders.value.filter(function (order: any) {
              return (
                order.State == 40 &&
                new Date(order.DepInfo.depDate) >= new Date(choosedDate[0]) &&
                new Date(order.DepInfo.depDate) <= new Date(choosedDate[1]) &&
                (value
                  .toLowerCase()
                  .split(" ")
                  .every((v: any) =>
                    order.DepInfo.depCity.toLowerCase().includes(v)
                  ) ||
                  value
                    .toLowerCase()
                    .split(" ")
                    .every((v: any) =>
                      order.DepInfo.destCity.toLowerCase().includes(v)
                    ) ||
                  value
                    .toLowerCase()
                    .split(" ")
                    .every((v: any) =>
                      order.DepInfo.airlines.toLowerCase().includes(v)
                    ) ||
                  value
                    .toLowerCase()
                    .split(" ")
                    .every((v: any) => order.Id.toString().includes(v)))
              );
            });
          } else if (selectedState.value.name == "Обрабатывается") {
            activeOrders.value = userOrders.value.filter(function (order: any) {
              return (
                order.State == 55 ||
                (order.State == 65 &&
                  new Date(order.DepInfo.depDate) >= new Date(choosedDate[0]) &&
                  new Date(order.DepInfo.depDate) <= new Date(choosedDate[1]) &&
                  (value
                    .toLowerCase()
                    .split(" ")
                    .every((v: any) =>
                      order.DepInfo.depCity.toLowerCase().includes(v)
                    ) ||
                    value
                      .toLowerCase()
                      .split(" ")
                      .every((v: any) =>
                        order.DepInfo.destCity.toLowerCase().includes(v)
                      ) ||
                    value
                      .toLowerCase()
                      .split(" ")
                      .every((v: any) =>
                        order.DepInfo.airlines.toLowerCase().includes(v)
                      ) ||
                    value
                      .toLowerCase()
                      .split(" ")
                      .every((v: any) => order.Id.toString().includes(v))))
              );
            });
          } else if (selectedState.value.name == "Оформлен") {
            activeOrders.value = userOrders.value.filter(function (order: any) {
              return (
                order.State == 60 &&
                new Date(order.DepInfo.depDate) >= new Date(choosedDate[0]) &&
                new Date(order.DepInfo.depDate) <= new Date(choosedDate[1]) &&
                (value
                  .toLowerCase()
                  .split(" ")
                  .every((v: any) =>
                    order.DepInfo.depCity.toLowerCase().includes(v)
                  ) ||
                  value
                    .toLowerCase()
                    .split(" ")
                    .every((v: any) =>
                      order.DepInfo.destCity.toLowerCase().includes(v)
                    ) ||
                  value
                    .toLowerCase()
                    .split(" ")
                    .every((v: any) =>
                      order.DepInfo.airlines.toLowerCase().includes(v)
                    ) ||
                  value
                    .toLowerCase()
                    .split(" ")
                    .every((v: any) => order.Id.toString().includes(v)))
              );
            });
          } else if (selectedState.value.name == "Отменён") {
            activeOrders.value = userOrders.value.filter(function (order: any) {
              return (
                (order.State == 70 ||
                  order.State == 71 ||
                  order.State == 72 ||
                  order.State == 73 ||
                  order.State == 74) &&
                new Date(order.DepInfo.depDate) >= new Date(choosedDate[0]) &&
                new Date(order.DepInfo.depDate) <= new Date(choosedDate[1]) &&
                (value
                  .toLowerCase()
                  .split(" ")
                  .every((v: any) =>
                    order.DepInfo.depCity.toLowerCase().includes(v)
                  ) ||
                  value
                    .toLowerCase()
                    .split(" ")
                    .every((v: any) =>
                      order.DepInfo.destCity.toLowerCase().includes(v)
                    ) ||
                  value
                    .toLowerCase()
                    .split(" ")
                    .every((v: any) =>
                      order.DepInfo.airlines.toLowerCase().includes(v)
                    ) ||
                  value
                    .toLowerCase()
                    .split(" ")
                    .every((v: any) => order.Id.toString().includes(v)))
              );
            });
          }
        }
      }
    );

    return {
      inputValue,
      placeholder,
      dates1,
      dates2,
      minDate,
      maxDate,
      invalidDates,
      selectedState,
      states,
      isLoading,
      error,
      userOrders,
      getOrders,
      activeUserOrders,
      activeOrders,
      getInputFilter,
      getDateFilter,
      getStateNameFilter,
      getStateCodeFilter,
    };
  },

  data() {
    return {};
  },
  created() {
    // Dispatching fetch from store when created
    // then put it in userOrders
    this.getOrders();
  },
  methods: {
    //Method for Show all orders button
    showAllBtn() {
      this.activeOrders = this.userOrders;
      this.selectedState = { name: "Все заказы", code: "0" };
      this.dates2 = null;
      this.inputValue = "";
    },
    //Method for hiding calendar after picking both dates
    onSelectDate() {
      const calendar: any = this.$refs.dateSelect ?? null;
      if (
        calendar &&
        Array.isArray(calendar.modelValue) &&
        calendar.modelValue.length >= 2 &&
        calendar.modelValue[1] == null
      ) {
        calendar.overlayVisible = false;
      }
    },
  },
  beforeRouteLeave(to: any, from: any, next: any) {
    // console.log(this.dates2);
    // console.log(this.inputValue);
    // console.log(this.selectedState);
    if (
      this.dates2 !== null &&
      this.inputValue &&
      this.selectedState !== null &&
      this.selectedState.name !== "Без фильтрации"
    ) {
      sessionStorage.setItem("dates", JSON.stringify(this.dates2));
      sessionStorage.setItem("search", JSON.stringify(this.inputValue));
      sessionStorage.setItem(
        "stateName",
        JSON.stringify(this.selectedState.name)
      );
      sessionStorage.setItem(
        "stateCode",
        JSON.stringify(this.selectedState.code)
      );
    } else if (this.inputValue && this.dates2 !== null) {
      sessionStorage.setItem("search", JSON.stringify(this.inputValue));
      sessionStorage.setItem("dates", JSON.stringify(this.dates2));
      sessionStorage.removeItem("stateName");
      sessionStorage.removeItem("stateCode");
    } else if (
      this.selectedState !== null &&
      this.selectedState.name !== "Без фильтрации" &&
      this.inputValue
    ) {
      sessionStorage.setItem(
        "stateName",
        JSON.stringify(this.selectedState.name)
      );
      sessionStorage.setItem(
        "stateCode",
        JSON.stringify(this.selectedState.code)
      );
      sessionStorage.removeItem("dates");
      sessionStorage.setItem("search", JSON.stringify(this.inputValue));
    } else if (
      this.selectedState !== null &&
      this.selectedState.name !== "Без фильтрации" &&
      this.dates2 !== null
    ) {
      sessionStorage.setItem(
        "stateName",
        JSON.stringify(this.selectedState.name)
      );
      sessionStorage.setItem(
        "stateCode",
        JSON.stringify(this.selectedState.code)
      );
      sessionStorage.setItem("dates", JSON.stringify(this.dates2));
      sessionStorage.removeItem("search");
    } else if (this.dates2 !== null) {
      sessionStorage.setItem("dates", JSON.stringify(this.dates2));
      sessionStorage.removeItem("stateName");
      sessionStorage.removeItem("stateCode");
      sessionStorage.removeItem("search");
    } else if (this.inputValue) {
      sessionStorage.setItem("search", JSON.stringify(this.inputValue));
      sessionStorage.removeItem("stateName");
      sessionStorage.removeItem("stateCode");
    } else if (
      this.selectedState !== null &&
      this.selectedState.name !== "Без фильтрации"
    ) {
      sessionStorage.setItem(
        "stateName",
        JSON.stringify(this.selectedState.name)
      );
      sessionStorage.setItem(
        "stateCode",
        JSON.stringify(this.selectedState.code)
      );
      sessionStorage.removeItem("search");
      sessionStorage.removeItem("dates");
    } else {
      sessionStorage.removeItem("stateName");
      sessionStorage.removeItem("stateCode");
      sessionStorage.removeItem("search");
      sessionStorage.removeItem("dates");
    }
    next();
  },
  computed: {},

  directives: {
    //Directive for ripple styling effect
    ripple: Ripple,
  },
});
